import { View, Text } from "react-native";
import { ImageIcon } from "lucide-react-native";
import { EMBER } from "../../../onboarding/theme";

type Props = {
  label: string;
  description?: string;
};

export default function DiagramPlaceholder({ label, description }: Props) {
  return (
    <View
      style={{
        borderWidth: 1.5,
        borderStyle: "dashed",
        borderColor: "rgba(0,0,0,0.1)",
        borderRadius: 16,
        backgroundColor: "rgba(0,0,0,0.02)",
        padding: 24,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 140,
        marginTop: 12,
        gap: 10,
      }}
    >
      <ImageIcon size={24} color={EMBER.colors.textFaint} strokeWidth={1.5} />
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 13,
          fontWeight: "600",
          color: EMBER.colors.textMid,
          textAlign: "center",
        }}
      >
        {label}
      </Text>
      {description && (
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 12,
            color: EMBER.colors.textFaint,
            textAlign: "center",
          }}
        >
          {description}
        </Text>
      )}
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 10,
          color: EMBER.colors.textFaint,
          fontStyle: "italic",
          marginTop: 4,
        }}
      >
        Illustration coming soon
      </Text>
    </View>
  );
}
